import {MessageBase} from './message-base';

export class MessageGridSelected  extends MessageBase<MessageGridSelected> {
  // tslint:disable-next-line:variable-name
  private _idGrid: string;
  // tslint:disable-next-line:variable-name
  private _description: string;
  constructor(idGrid: string, description: string) {
    super(MessageGridSelected);

    this._idGrid = idGrid;
    this._description = description;
  }


  public get idGrid(): string {
    return this._idGrid;
  }

  get description(): string {
    return this._description;
  }
}
